import React from 'react';
import classNames from 'classnames';
import { SectionProps } from '../../utils/SectionProps';
import Image from '../elements/Image';

const propTypes = {
  ...SectionProps.types
}

const defaultProps = {
  ...SectionProps.defaults
}

class Clients extends React.Component {

  render() {
    const {
      className,
      topOuterDivider,
      bottomOuterDivider,
      topDivider,
      bottomDivider,
      hasBgColor,
      invertColor,
      ...props
    } = this.props;

    const outerClasses = classNames(
      'clients section reveal-fade',
      topOuterDivider && 'has-top-divider',
      bottomOuterDivider && 'has-bottom-divider',
      hasBgColor && 'has-bg-color',
      invertColor && 'invert-color',
      className
    );

    const innerClasses = classNames(
      'clients-inner section-inner',
      topDivider && 'has-top-divider',
      bottomDivider && 'has-bottom-divider'
    );

    return (
      <section
        {...props}
        className={outerClasses}
      >
        <div className="container">
          <div
            className={innerClasses}
          >
            <ul className="list-reset">
              <li className="reveal-from-bottom">
                <Image
                  src={require('./../../assets/images/clients/1.svg')}
                  alt="Cliente"
                  width={124}
                  height={24} />
              </li>
              <li className="reveal-from-bottom">
                <Image
                  src={require('./../../assets/images/clients/2.svg')}
                  alt="Cliente"
                  width={124}
                  height={24} />
              </li>
              <li className="reveal-from-bottom">
                <Image
                  src={require('./../../assets/images/clients/3.svg')}
                  alt="Cliente"
                  width={124}
                  height={24} />
              </li>
              <li className="reveal-from-bottom">
                <Image
                  src={require('./../../assets/images/clients/4.svg')}
                  alt="Cliente"
                  width={124}
                  height={24} />
              </li>
              <li className="reveal-from-bottom">
                <Image
                  src={require('./../../assets/images/clients/5.svg')}
                  alt="Cliente"
                  width={124}
                  height={24} />
              </li>
              <li className="reveal-from-bottom">
                <Image
                  src={require('./../../assets/images/clients/6.svg')}
                  alt="Cliente"
                  width={124}
                  height={24} />
              </li>
              <li className="reveal-from-bottom">
                <Image
                  src={require('./../../assets/images/clients/7.svg')}
                  alt="Cliente"
                  width={124}
                  height={24} />
              </li>
              <li className="reveal-from-bottom">
                <Image
                  src={require('./../../assets/images/clients/8.svg')}
                  alt="Cliente"
                  width={124}
                  height={24} />
              </li>
              <li className="reveal-from-bottom">
                <Image
                  src={require('./../../assets/images/clients/9.svg')}
                  alt="Cliente"
                  width={124}
                  height={24} />
              </li>
              <li className="reveal-from-bottom">
                <Image
                  src={require('./../../assets/images/clients/10.svg')}
                  alt="Cliente"
                  width={124}
                  height={24} />
              </li>
              <li className="reveal-from-bottom">
                <Image
                  src={require('./../../assets/images/clients/11.svg')}
                  alt="Cliente"
                  width={124}
                  height={24} />
              </li>
            </ul>
          </div>
        </div>
      </section>
    );
  }
}

Clients.propTypes = propTypes;
Clients.defaultProps = defaultProps;

export default Clients;